import { Base_URL } from '../Client/apiURL';

export const ASSIGNED_MOCK_LABEL = 'Assigned by your institution';
export const ASSIGNED_MOCK_EMPTY = "Your institution hasn't assigned any mock tests yet.";

export function canAccessMockTest(access, kind, testId) {
  if (!access) return false;
  if (access.restricted === false) return true;
  return [...access.assignments, ...access.resumable].some(
    (entry) => entry.kind === kind && Number(entry.testId) === Number(testId)
  );
}

export async function fetchMockTestAccess() {
  const response = await fetch(`${Base_URL}/app/users/mock-test-access`, { method: 'GET', credentials: 'include', cache: 'no-store' });
  const data = await response.json();
  const access = data?.response;
  if (!response.ok || data?.responseCode !== 200 || typeof access?.restricted !== 'boolean'
    || !Array.isArray(access.assignments) || !Array.isArray(access.resumable)) {
    throw new Error('Unable to check mock-test access. Please retry.');
  }
  return access;
}
